import classNames from 'classnames';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import '@progress/kendo-theme-default/dist/all.css';

const Loading = (props: Props) => {
	let portalSelector;
	if (props.loadingPosition !== undefined) {
		if (props.loadingPosition === 'grid') portalSelector = '.k-grid-content';
		else if (props.loadingPosition === 'content' || props.loadingPosition === 'fixed') portalSelector = '#bodyContent';
		else portalSelector = props.loadingPosition;
	}

	const panel = (
		<LoadingElement
			noSpinner={props.noSpinner}
			fixed={props.loadingPosition === 'fixed'}
			// TODO: Find out why we need this "alternativePosition" and why default to true. It breaks the overlay feature of Kendo loading
			alternativePosition={props.alternativePosition ?? true}
		/>
	);
	if (props.usePortal !== false) {
		const portal = document && document.querySelector(portalSelector);
		if (portal) return ReactDOM.createPortal(panel, portal);
	}
	return panel;
};

interface Props {
	// TODO string is for generic query, consider separating for better typing.
	loadingPosition?: 'content' | 'grid' | 'fixed' | string | null;
	noSpinner?: boolean; // if false, will just load the overlay
	usePortal?: boolean;
	alternativePosition?: boolean;
}

const LoadingElement = (props: { noSpinner: boolean; fixed: boolean; alternativePosition: boolean }) => (
	<div
		className={classNames('loadingPanel', 'k-loading-mask', props.alternativePosition ? 'alternativePosition' : null)}
		id="loading"
	>
		<span className="k-loading-text">Loading</span>
		{!props.noSpinner && <div className={classNames({ 'k-loading-image highlightColor': true, fixed: props.fixed })} />}
		<div className="k-loading-color" />
	</div>
);

export default Loading;

Loading.defaultProps = {
	loadingPosition: null,
	noSpinner: false,
	usePortal: false,
	alternativePosition: false
};
